module.exports = __webpack_public_path__ + "static/06-9b82bcb5cacd5625869fdae993bfcdab.png";